import styled from "styled-components";
import { borderRadius, fontWeights, spacing, typographyMixin } from "@magicbi/ui-library";

const box = `
  border: 1px solid;
  min-width: 0;
`;

/** With a kicker: kicker on top, the sentence under it. */
export const Region = styled.section`
  ${box}
  display: grid;
  gap: ${spacing[1]};
  padding: ${spacing[4]} ${spacing[5]};
  border-color: ${({ theme }) => theme.colors.primary[200]};
  border-radius: ${borderRadius.xl};
  background: ${({ theme }) => theme.colors.background.tertiary};
`;

/** Without a kicker: the icon beside the sentence. */
export const Row = styled.div`
  ${box}
  display: flex;
  align-items: flex-start;
  gap: ${spacing[3]};
  padding: ${spacing[3]} ${spacing[4]};
  border-color: ${({ theme }) => theme.colors.primary[200]};
  border-radius: ${borderRadius.xl};
  background: ${({ theme }) => theme.colors.background.tertiary};
  & > [data-part="icon"] {
    display: inline-flex;
    flex: none;
    margin-top: ${spacing[1]};
    color: ${({ theme }) => theme.colors.text.link};
  }
  & > [data-part="icon"] > svg {
    width: 1.125rem;
    height: 1.125rem;
  }
`;

export const Kicker = styled.h2`
  display: flex;
  align-items: center;
  gap: ${spacing[1]};
  margin: 0;
  ${typographyMixin("caption", 2)}
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${({ theme }) => theme.colors.text.link};
  & > span {
    display: inline-flex;
  }
  & > span > svg {
    width: 0.75rem;
    height: 0.75rem;
  }
`;

export const Sentence = styled.p<{ $size: "md" | "lg" }>`
  max-width: 70ch;
  margin: 0;
  ${({ $size }) => ($size === "lg" ? typographyMixin("subtitle", 3) : typographyMixin("body", 3))}
  line-height: ${({ $size }) => ($size === "lg" ? "1.625rem" : "1.5rem")};
  color: ${({ theme }) => theme.colors.text.primary};
  b {
    font-weight: ${fontWeights.bold};
  }
`;
